// extracted by mini-css-extract-plugin
export default {"wrapper":"GoogleLogin_wrapper__a5-oE"};